import { useIxmUserauthV1OrganizationQueryServiceOrganizationList } from '@interxfi/api-client/generated/hooks/ixm-userauth-v1-organization-query-service-organization-list';
import type { IxmUserauthV1OrganizationState } from '@interxfi/types/generated/api';
import { createDataCombobox } from '../data-combobox-builder';

export function getOrganizationLabel(organization: IxmUserauthV1OrganizationState): string {
  return organization.data?.profile?.name || organization.organizationId || 'Unknown Organization';
}

export const { DataComboboxInput: UserauthOrganizationCombobox, DataComboboxInputWithLens: UserauthOrganizationComboboxWithLens } =
  createDataCombobox<typeof useIxmUserauthV1OrganizationQueryServiceOrganizationList, 'organization', 'organizationId'>({
    dataValueKey: 'organizationId',
    entityName: 'organizations',
    responseDataKey: 'organization',
    useInfiniteQuery: useIxmUserauthV1OrganizationQueryServiceOrganizationList,
    optionDisplayBuilder: (organization) => ({
      label: getOrganizationLabel(organization),
    }),
  });
